import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/RecallsDashboard.css";
import { useHistory } from "react-router-dom";

const MESES = [
  "Enero", "Febrero", "Marzo", "Abril",
  "Mayo", "Junio", "Julio", "Agosto",
  "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export default function RecallsDashboard() {

    const hoy = new Date();
    const mesActual = hoy.getMonth() + 1;
    const mesSigActual = hoy.getMonth() + 2;
    const anioActual = hoy.getFullYear();

    const [year, setYear] = useState(anioActual);
    const [estadoMeses, setEstadoMeses] = useState({});
    const [mesSeleccionado, setMesSeleccionado] = useState(null);
    const [recalls, setRecalls] = useState([]);
    const [clinicaFiltro, setClinicaFiltro] = useState("ALL");
    const [estadoFiltro, setEstadoFiltro] = useState("ALL");
    const [ordenFecha, setOrdenFecha] = useState("ASC");
    const history = useHistory();

  // ===============================
  // Cargar estado de meses
  // ===============================
    const authConfig = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    };
    
    const cargarMeses = () => {
        axios.get(`/api/recalls/dashboard/${year}`, authConfig)
        .then(res => setEstadoMeses(res.data));
    };

    const formatearMotivo = (motivo) => {
        return motivo
            ?.toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, l => l.toUpperCase());
    };

    useEffect(() => {
        cargarMeses();
        setMesSeleccionado(null);
        setRecalls([]);
    }, [year]);

    // ===============================
    // Cargar recalls de un mes
    // ===============================
    const abrirMes = (mes) => {
        setClinicaFiltro("ALL");
        setEstadoFiltro("ALL");
        setOrdenFecha("ASC");
        setMesSeleccionado(mes);
        axios.get(`/api/recalls/dashboard/${year}/${mes}`, authConfig)
        .then(res => setRecalls(res.data));
    };

    const ESTADOS = ["PENDIENTE", "REALIZADO", "CANCELADO", "CITADO"];

    const cambiarEstado = (recall) => {
        const index = ESTADOS.indexOf(recall.estado);
        const siguiente = ESTADOS[(index + 1) % ESTADOS.length];

        axios.put(
            `/api/recalls/${recall.id}/estado?estado=${siguiente}`,
            {},
            authConfig
        ).then(() => {
            setRecalls(prev =>
            prev.map(r =>
                r.id === recall.id ? { ...r, estado: siguiente } : r
            )
            );
        });
    };
    const siguienteMes = mesActual === 12 ? 1 : mesActual + 1;
    const anioSiguienteMes = mesActual === 12 ? anioActual + 1 : anioActual;

    const esMesEditable =
        (year === anioActual && mesSeleccionado === mesActual) ||
        (year === anioSiguienteMes && mesSeleccionado === siguienteMes);

    const recallsFiltrados = recalls
        .filter(r =>
            clinicaFiltro === "ALL" ||
            r.clinica === clinicaFiltro
        )
        .filter(r =>
            estadoFiltro === "ALL" ||
            r.estado === estadoFiltro
        )
        .sort((a, b) => {
            const fechaA = new Date(a.fechaRecall);
            const fechaB = new Date(b.fechaRecall);

            return ordenFecha === "ASC"
                ? fechaA - fechaB
                : fechaB - fechaA;
        });
    return (
        <div className="recalls-dashboard">

        {/* ================= CABECERA ================= */}
        <header className="recalls-header">
            <button onClick={() => setYear(y => y - 1)}>◀</button>
            <h2>Recalls · {year}</h2>
            <button onClick={() => setYear(y => y + 1)}>▶</button>
        </header>

        {/* ================= MESES ================= */}
        <section className="meses-grid">
            {MESES.map((nombre, i) => {
            const mes = i + 1;
            const tiene = estadoMeses[mes];

            return (
                <div
                key={mes}
                    className={`mes 
                    ${estadoMeses[mes] === "COMPLETO" ? "completo" : ""}
                    ${estadoMeses[mes] === "PENDIENTE" ? "activo" : ""}
                    ${estadoMeses[mes] === "VACIO" ? "vacio" : ""}
                    `}
                onClick={() => tiene && abrirMes(mes)}
                >
                {nombre}
                </div>
            );
            })}
        </section>

        {/* ================= LISTADO MES ================= */}
        {mesSeleccionado && (
            <section className="recalls-mes">

            <h3>
                {MESES[mesSeleccionado - 1]}
                {!esMesEditable && " (solo lectura)"}
            </h3>
            <div className="recalls-filtros">
                {/* CLÍNICA */}
                <div className="filtro-dropdown">
                    <button className="filtro-dropdown-btn">
                        Clínica: {
                            clinicaFiltro === "ALL"
                                ? "Todas"
                                : clinicaFiltro === "LA ELIPA"
                                    ? "La Elipa"
                                    : "VEN"
                        }
                        <span>▾</span>
                    </button>

                    <div className="filtro-dropdown-menu">
                        <button onClick={() => setClinicaFiltro("ALL")}>
                            Todas
                        </button>

                        <button onClick={() => setClinicaFiltro("LA ELIPA")}>
                            La Elipa
                        </button>

                        <button onClick={() => setClinicaFiltro("VEN")}>
                            VEN
                        </button>
                    </div>
                </div>
                {/* ESTADO */}
                <div className="filtro-dropdown">
                    <button className="filtro-dropdown-btn">
                        Estado: {
                            estadoFiltro === "ALL"
                                ? "Todos"
                                : formatearMotivo(estadoFiltro)
                        }
                        <span>▾</span>
                    </button>

                    <div className="filtro-dropdown-menu">
                        <button onClick={() => setEstadoFiltro("ALL")}>
                            Todos
                        </button>
                        <button onClick={() => setEstadoFiltro("PENDIENTE")}>
                            Pendiente
                        </button>
                        <button onClick={() => setEstadoFiltro("CITADO")}>
                            Citado
                        </button>
                        <button onClick={() => setEstadoFiltro("REALIZADO")}>
                            Realizado
                        </button>
                        <button onClick={() => setEstadoFiltro("CANCELADO")}>
                            Cancelado
                        </button>
                    </div>
                </div>

                {/* ORDEN */}
                <div className="filtro-dropdown">
                    <button className="filtro-dropdown-btn">
                        Fecha: {
                            ordenFecha === "ASC"
                                ? "menor a mayor"
                                : "mayor a menor"
                        }
                        <span>▾</span>
                    </button>

                    <div className="filtro-dropdown-menu">
                        <button onClick={() => setOrdenFecha("ASC")}>
                            Menor a mayor
                        </button>
                        <button onClick={() => setOrdenFecha("DESC")}>
                            Mayor a menor
                        </button>
                    </div>
                </div>

            </div>
            <table className={`recalls-table ${!esMesEditable ? "solo-lectura" : ""}`}>
                <thead>
                <tr>
                    <th>Clínica</th>
                    <th>Paciente</th>
                    <th>Fecha</th>
                    <th>Motivo</th>
                    <th>Comentario</th>
                    <th>Estado</th>
                    <th>Fecha recall</th>
                </tr>
                </thead>
                <tbody>
                {recallsFiltrados.map(r => (
                    <tr
                        key={r.id}
                        onDoubleClick={() =>
                            history.push(`/pacientes/${r.nExpediente}`)
                        }
                    >
                    <td>{r.clinica}</td>
                    <td>
                        <span
                            className="link-paciente"
                            onClick={() =>
                                history.push(
                                    `/pacientes/${r.nExpediente}`
                                )
                            }
                        >
                            {r.pacienteNombre}
                        </span>
                    </td>
                    <td>
                        {new Date(r.fechaRecall).toLocaleDateString("es-ES")}
                    </td>
                    <td>{formatearMotivo(r.motivo)}</td>
                    <td>{r.comentario}</td>
                    <td>
                        <span
                            className={`estado-badge estado-${r.estado.toLowerCase()}`}
                            onClick={() => esMesEditable && cambiarEstado(r)}
                        >
                            {formatearMotivo(r.estado)}
                        </span>
                    </td>
                    <td>
                        {r.fechaRealizado
                            ? new Date(r.fechaRealizado).toLocaleDateString("es-ES")
                            : "-"
                        }
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>

            </section>
        )}

        </div>
    );
}
